export const en = {
  // Common
  conversation: 'Conversation',
  connected: 'Connected',
  disconnected: 'Disconnected',
  loading: 'Loading...',
  error: 'Error',
  
  // Welcome messages
  welcomeMessage: 'Hello, how can I help you today?',
  joinedChat: 'joined the chat',
  
  // Chat actions
  createNewChat: 'Create a new conversation',
  newConversation: 'New conversation',
  moreResults: 'I want more results',
  
  // Input placeholders
  inputPlaceholder: 'Type a message...',
  inputPlaceholderGenerating: 'Generating results...',
  
  // Loading messages
  collectingInfo: 'Collecting necessary information ...',
  searchingBestResults: 'Searching for the best results ...',
  analyzingDatabase: 'Analyzing database for search ...',
  checkingSpecialOffers: 'Checking available special offers ...',
  searchingSimilarProducts: 'Searching for similar products ...',
  preparingRecommendations: 'Preparing personalized recommendations ...',
  checkingStock: 'Checking stock and product availability ...',
  finalizingResponse: 'Finalizing response with the most relevant options ...',
  
  // Thinking steps
  analyzingRequest: 'Analyzing your request ...',
  generatingSearchTerms: 'Generating search terms ...',
  processingSearchTerms: 'Processing search terms ...',
  searchingDatabase: 'Searching database for suitable products ...',
  processingResults: 'Processing found results ...',
  generatingEstimates: 'Generating time and cost estimates ...',
  generatingFinalResponse: 'Generating final response ...',
  processingRequest: 'Findly is thinking ...',
  
  // Status messages
  waitingPreviousResults: 'Waiting for previous conversation results ...',
  checkingContinuation: 'Checking if conversation can continue...',
  
  // Empty states
  noMessagesYet: 'No messages yet',
  
  // Error messages
  failedCreateChat: 'Failed to create a new chat. Please try again.',
  errorCreatingChat: 'Error creating chat',
  errorSendingMessage: 'Error sending message',
  errorLoadingChats: 'Error loading chats',
  
  // Cart messages
  productAddedToCart: 'Product {{productCode}} has been added to cart!',
  
  // Chat titles
  defaultChatTitle: 'Chat {{timestamp}}',
  
  // Connection status
  connectionStatusConnected: 'Connected 🟢',
  connectionStatusDisconnected: 'Disconnected 🔴',

  // Chat encouragement messages (cycled every 5 seconds)
  chatEncouragement1: 'I can help you find the products you are looking for!',
  chatEncouragement2: 'Need help finding something specific?',
  chatEncouragement3: 'Let me assist you with your shopping!'
};
